module.exports = __webpack_public_path__ + "img/A5-2-plan.beded4bd.png";